/**
 * VideoMessageCard
 * The pinned card that sits above the to-do list until the kid watches the
 * teacher's clip and presses done.
 */

import React from 'react';
import { Play } from 'lucide-react';
import './VideoMessages.css';

function VideoMessageCard({ message, onOpen, disabled = false }) {
  // A kept message is one the kid has already seen and chose to hold on to —
  // saying so stops it nagging like something brand new.
  const kept = !!message.watched_at;

  return (
    <button
      type="button"
      className={`video-message-card${kept ? ' kept' : ''}`}
      onClick={() => onOpen?.(message)}
      disabled={disabled}
      data-testid="video-message-card"
    >
      <div className="video-message-card-info">
        <div className="video-message-card-title">
          {kept ? '🎥 再看一次老师的留言' : '🎥 老师给你的留言'}
        </div>
        {message.title && (
          <div className="video-message-card-secondary">{message.title}</div>
        )}
      </div>
      <div className="video-message-card-play" aria-hidden="true">
        <Play size={18} fill="currentColor" />
      </div>
    </button>
  );
}

/**
 * Every waiting message, oldest first (the server already orders them).
 * Teacher view passes `disabled` — a teacher can see what the kid is looking
 * at but must not consume the message on their behalf.
 */
export default function VideoMessageList({ messages = [], onOpen, disabled = false }) {
  if (messages.length === 0) return null;

  return (
    <div className="video-message-list">
      {messages.map(message => (
        <VideoMessageCard
          key={message.id}
          message={message}
          onOpen={onOpen}
          disabled={disabled}
        />
      ))}
    </div>
  );
}

export { VideoMessageCard };
